import { createSlice, SliceCaseReducers } from '@reduxjs/toolkit';
import { buildSubStateSelector } from '../../../store/utilities/useAppStateSelector';

export interface EventsTableAppState {
  events: any[];
  totalPages: number;
  pageIndex: number;
  pageSize: number;
  sortedColumnName: string;
  sortDirection: string;
  searchTerm: string;
  loading: boolean;
}

const initialState: EventsTableAppState = {
  events: [],
  totalPages: 0,
  pageIndex: 0,
  pageSize: 25,
  sortedColumnName: 'publishedAt',
  sortDirection: 'desc',
  searchTerm: '',
  loading: false,
};

export const slice = createSlice<EventsTableAppState, SliceCaseReducers<EventsTableAppState>>({
  name: 'eventsTable',
  initialState,
  reducers: {
    setEvents: (state, action) => {
      state.events = action.payload;
    },
    setTotalPages: (state, action) => {
      state.totalPages = action.payload;
    },
    setPageIndex: (state, action) => {
      state.pageIndex = action.payload;
    },
    setPageSize: (state, action) => {
      state.pageSize = action.payload;
    },
    setSortedColumnName: (state, action) => {
      state.sortedColumnName = action.payload;
    },
    setSortDirection: (state, action) => {
      state.sortDirection = action.payload;
    },
    setSearchTerm: (state, action) => {
      state.searchTerm = action.payload;
    },
    setLoading: (state, action) => {
      state.loading = action.payload;
    },
  },
});

export const useAppStateEventsTableSelector = buildSubStateSelector<EventsTableAppState>(
  (state) => state.eventsTable,
);

export const {
  setEvents,
  setTotalPages,
  setPageIndex,
  setPageSize,
  setSortedColumnName,
  setSortDirection,
  setSearchTerm,
  setLoading,
} = slice.actions;

export const eventsTableReducer = slice.reducer;
